import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Events from "views/admin/events/AllEventsList";
import Posts from "views/admin/posts/AllEventsList";
import Garages from "views/admin/list_garages";
import EventAndCarTypes from "views/admin/events";

const PRIMARY_OPTIONS = [
  { label: "Events", value: "events" },
  { label: "Posts", value: "posts" },
  { label: "Garages", value: "garages" },
];

const Explore = () => {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  
  // Set initial option based on URL parameter
  const getInitialOption = () => {
    if (tabParam === "garages") {
      return PRIMARY_OPTIONS.find(opt => opt.value === "garages") || PRIMARY_OPTIONS[0];
    } else if (tabParam === "posts") {
      return PRIMARY_OPTIONS.find(opt => opt.value === "posts") || PRIMARY_OPTIONS[0];
    }
    return PRIMARY_OPTIONS[0];
  };

  const [primaryOption, setPrimaryOption] = useState(getInitialOption());

  // Update option when URL parameter changes (from navbar dropdown)
  useEffect(() => {
    const newOption = getInitialOption();
    setPrimaryOption(newOption);
  }, [tabParam]);

  const renderPrimary = () => {
    switch (primaryOption.value) {
      case "posts":
        return <Posts key="explore-posts" />;
      case "garages":
        return <Garages key="explore-garages" />;
      case "event-car-types":
        return <EventAndCarTypes key="explore-event-car-types" />;
      case "events":
      default:
        return <Events key="explore-events" />;
    }
  };

  return (
    <div className="mt-3 grid h-full grid-cols-1 gap-8">
      <div>{renderPrimary()}</div>
    </div>
  );
};

export default Explore;

